import { showSuccess, showApiError } from "@/lib/toast";
import { uploadWithoutContent } from "@/sideEffects/api";
import { useMutation } from "@tanstack/react-query";
import { TemplateSettingsInspectorContent } from "./TemplateSettingsInspectorContent";
import { useBackgroundOptions } from "@/components/canvas/hooks/useBackgroundOptions";
import { selectActiveFirm } from "@/store/appSelectors";
import { useSelector } from "react-redux";
import { getContentFullUrl } from "@/lib/contentUtils";
import { useTranslation } from "react-i18next";

export const TemplateSettingsInpector = () => {
  const { t } = useTranslation();
  const activeFirm = useSelector(selectActiveFirm);
  const { backgroundOptions, updateBackgroundOptionsAndDispatchChangeBackgroundOptionsEvent } = useBackgroundOptions();

  const uploadMutation = useMutation({
    mutationFn: (file: File) =>
      uploadWithoutContent({
        firmGuid: String(activeFirm?.firmGuid),
        files: [file],
        name: file.name,
      }),
    onSuccess: (data) => {
      if (!data.data) return;
      const imageUrl = getContentFullUrl(data.data.value.contentStorageName);
      const updatedOptions: Partial<typeof backgroundOptions> = {
        imageUrl: imageUrl,
        fillMode: backgroundOptions?.fillMode ?? "cover",
      };
      updateBackgroundOptionsAndDispatchChangeBackgroundOptionsEvent(updatedOptions);
      showSuccess(t("common.imageUploaded"));
    },
    onError: showApiError,
  });

  const handleDeleteImageClick = () => {
    const updatedOptions: Partial<typeof backgroundOptions> = {
      imageUrl: null,
      imageOpacity: 1,
    };
    updateBackgroundOptionsAndDispatchChangeBackgroundOptionsEvent(updatedOptions);
  };

  return (
    <>
      <TemplateSettingsInspectorContent
        imageUrlOption={{
          value: backgroundOptions?.imageUrl ?? "",
          onChange: (file) => uploadMutation.mutate(file),
          onDelete: handleDeleteImageClick,
          isLoading: uploadMutation.isPending,
        }}
      />
    </>
  );
};
